export const LOGIN = 'LOGIN'
export const SIGNUP = 'SIGNUP'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const LOGOUT = 'LOGOUT'
export const GET_PROFILE = 'GET_PROFILE'
export const EDIT_PROFILE = 'EDIT_PROFILE'
export const DELETE_PROFILE = 'DELETE_PROFILE'